export const getBaseURL = () => {
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'development') {
    return 'http://localhost:8080';
  }

  if (
    process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview' &&
    process.env.NEXT_PUBLIC_VERCEL_URL
  ) {
    return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;
  }

  return process.env.NEXT_PUBLIC_ZAPIER_ORIGIN || 'https://zapier-staging.com';
};
